import { useState } from 'react';
import { useLocalStorage } from './useLocalStorage';

export type UseFavoritesReturnType = {
    favorites: string[];
    addFavorite: (svtId: string) => void;
    removeFavorite: (titleId: string | Array<string>) => void;
    ready: boolean;
    error: any;
};

export type UseIsFavoriteReturnType = {
    isFavorite: boolean;
    setIsFavorite: (val: boolean) => void;
};

export const useFavorites = (): UseFavoritesReturnType => {
    const [favorites, setFavorites, ready, error] = useLocalStorage('favorites', []);

    const addFavorite = (titleId: string) => {
        setFavorites([titleId, ...favorites]);
    };

    const removeFavorite = (titleId: string | Array<string>) => {
        if (typeof titleId === 'string') {
            setFavorites(favorites.filter((favorite) => favorite !== titleId));
        } else if (Array.isArray(titleId)) {
            setFavorites(favorites.filter((id) => titleId.includes(id) === false));
        }
    };

    return { favorites, addFavorite, removeFavorite, ready, error };
};

export const useIsFavorite = (titleId: string): UseIsFavoriteReturnType => {
    const [favorites] = useLocalStorage('favorites', []);
    const [isFavorite, setIsFavorite] = useState(favorites.some((favorite) => favorite === titleId));

    return { isFavorite, setIsFavorite };
};

export default useFavorites;
